import styled from '../../../styles/theme';
import { ToggleStyled } from '../ToggleStyled';

export const ToggleStyledAP = styled(ToggleStyled)`
    .toggleHandle {
        background: ${({ theme }) => theme.colors.primary};
        border: 1px solid ${({ theme }) => theme.colors.white};
    }
    .toggleHandleContainer {
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.primaryDisabled};
    }
    .toggleOption {
        color: ${({ theme }) => theme.colors.grey2};
        font-size: ${({ theme }) => theme.fontSizes.textSmall};
        &.toggled {
            color: ${({ theme }) => theme.colors.grey1};
        }
    }
`;
